export default __webpack_public_path__ + "static/media/alerts2.f2374175.svg";